export default __webpack_public_path__ + "static/media/jordihashbrown.decf4f70.gif";